import {createContext} from 'react';

export type AdditionalTextType = {
    save_btn_title: string;
    save_label: string;
    comment_btn_title: string;
    picture_btn_title: string;
    hyperlink_btn_title: string;
    undo_btn_title: string;
    img_dialog_title: string;
    edit_link_dialog_title: string;
    add_link_dialog_title: string;
    link_dialog_link_label: string;
    dialog_add_btn_label: string;
    link_dialog_link_placeholder: string;
    link_dialog_text_label: string;
    link_dialog_text_placeholder: string;
    ok_label: string;
    unlink_label: string;
    open_link: string;
    back_label: string;
    image_upload_label: string;
    image_alt_label: string;
    confirm: string;
    image_url: string;
    file_label: string;
};

export type RequiredTextType = {
    reduce_text_size: string;
    enlarge_text_size: string;

    hline_btn_title: string;

    cut_btn_title: string;
    copy_btn_title: string;
    paste_btn_title: string;

    emoji_btn_title: string;

    increase_indent_btn_title: string;
    decrease_indent_btn_title: string;

    bullets_btn_title: string;
    numbering_btn_title: string;

    align_r_btn_title: string;
    align_c_btn_title: string;
    align_l_btn_title: string;

    underline_btn_title: string;
    italic_btn_title: string;
    strikethrough_btn_title: string;
    bold_btn_title: string;
    txt_color_btn_title: string;
};

export const ToolbarDefaultTextContext: RequiredTextType & Partial<AdditionalTextType> = {
    reduce_text_size: 'Decrease font size',
    enlarge_text_size: 'Increase font size',
    save_btn_title: 'Save (Ctrl+S)',
    comment_btn_title: 'Add a Comment  (Ctrl+K)',
    picture_btn_title: 'Picture  (Ctrl+P)',
    hyperlink_btn_title: 'Hyperlink  (Ctrl+Q)',
    hline_btn_title: 'Horizontal Line  (Ctrl+H)',
    cut_btn_title: 'Cut (Ctrl+X)',
    copy_btn_title: 'Copy (Ctrl+C)',
    paste_btn_title: 'Paste (Ctrl+V)',
    emoji_btn_title: 'Add emoji',
    increase_indent_btn_title: 'Increase Indent  (Ctrl+>)',
    decrease_indent_btn_title: 'Decrease Indent  (Ctrl+<)',
    bullets_btn_title: 'Bullets  (Alt+B)',
    numbering_btn_title: 'Numbering  (Alt+N)',
    align_r_btn_title: 'Align Right  (Ctrl+R)',
    align_c_btn_title: 'Center  (Ctrl+M)',
    align_l_btn_title: 'Align Left  (Ctrl+L)',
    undo_btn_title: 'Undo  (Ctrl+Z)',
    underline_btn_title: 'Underline  (Ctrl+U)',
    italic_btn_title: 'Italic  (Ctrl+I)',
    strikethrough_btn_title: 'Strikethrough)',
    bold_btn_title: 'Bold  (Ctrl+B)',
    txt_color_btn_title: 'Set Text Color  (Ctrl+O)',
    img_dialog_title: 'Insert Image',
    edit_link_dialog_title: 'Edit link',
    add_link_dialog_title: 'Add link',
    link_dialog_link_label: 'URL',
    dialog_add_btn_label: 'Add',
    link_dialog_link_placeholder: 'Type or paste a link',
    link_dialog_text_label: 'Text',
    link_dialog_text_placeholder: 'Type the text for your link',
    ok_label: 'Ok',
    unlink_label: 'Unlink',
    open_link: 'Open link',
    back_label: 'Back',
    image_upload_label: 'Upload image',
    image_alt_label: 'Description',
    confirm: 'Confirm',
    image_url: 'Image URL',
    file_label: 'File'
};

export const TollbarTextsContext = createContext(ToolbarDefaultTextContext);
